import { getOfferName } from './title/getOfferName';
import { TComputedPropMapper } from '../../types/computed-props-mapper';

export const title: TComputedPropMapper<string> = (props, ctx) => {
  return props.offer.title || getOfferName(props.offer);
};
